function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * TimelineItem
 */
const TimelineItem = props => {
  const children = props.children || null;
  const Tag = props.tag;
  return /*#__PURE__*/React.createElement(Tag, _extends({
    className: classNames('timeline-item', props.className)
  }, props), children);
};

TimelineItem.defaultProps = {
  tag: 'div'
};
export default TimelineItem;